import { render, staticRenderFns } from "./CarrosselHero.vue?vue&type=template&id=1c3ccfb2"
var script = {}
import style0 from "./CarrosselHero.vue?vue&type=style&index=0&id=1c3ccfb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports